import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { FormatDate, Text } from '@reveni-io/reveni-ui'

const Eta = ({ eta }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!eta) return null

  return (
    <Text type="bodyMRegular" tag="span" color={theme.colors.text.subtle}>
      {t('Entrega estimada')}:{' '}
      <Text type="bodyMRegular" tag="span" color={theme.colors.text.default}>
        <FormatDate year="numeric" month="short" day="numeric" weekday="long">
          {eta}
        </FormatDate>
      </Text>
    </Text>
  )
}

export default Eta
